export const partnerProgramBenefitsSagaActionTypes = {
  callPartnerProgramBenefitsSaga: "callPartnerProgramBenefitsSaga",
  callGetBenefitsByTierSaga: "callGetBenefitsByTierSaga",
  callInsertPartnerProgramBenefitsSaga: "callInsertPartnerProgramBenefitsSaga",
  callDeletePartnerProgramBenefitCategorySaga:
    "callDeletePartnerProgramBenefitCategorySaga",
  callDeletePartnerProgramBenefitSaga: "callDeletePartnerProgramBenefitSaga",
};

export const getPartnerProgramBenefitsSagaAction: () => {
  type: string;
} = () => {
  return {
    type: partnerProgramBenefitsSagaActionTypes.callPartnerProgramBenefitsSaga,
  };
};

export type GetBenefitsByTierPayloadType = {
  tierId: number;
  benefitsType?: string;
  onSuccess?: (
    options: Array<{ label: string; value: string; id: number }>
  ) => void;
  onError?: (message?: string) => void;
};

export const getBenefitsByTierSagaAction: (
  data: GetBenefitsByTierPayloadType
) => {
  type: string;
  payload: GetBenefitsByTierPayloadType;
} = (data: GetBenefitsByTierPayloadType) => {
  return {
    type: partnerProgramBenefitsSagaActionTypes.callGetBenefitsByTierSaga,
    payload: data,
  };
};

export type InsertBenefitsPayloadType = {
  benefitCategories: {
    category_name: string;
    benefits: {
      ID?: number;
      benefits_name: string;
      description: string | null;
      sort_order: number;
      tier_ids: number[];
      benefits_type: string;
      benefits_status: number;
      delivery_type: string | null;
      weightage: number | null;
      frequency: string | null;
    }[];
  }[];
  onSuccess?: (message?: string) => void;
  onError?: (message?: string) => void;
};

export const insertPartnerProgramBenefitsSagaAction: (
  data: InsertBenefitsPayloadType
) => {
  type: string;
  payload: InsertBenefitsPayloadType;
} = (data: InsertBenefitsPayloadType) => {
  return {
    type: partnerProgramBenefitsSagaActionTypes.callInsertPartnerProgramBenefitsSaga,
    payload: data,
  };
};

export type DeleteBenefitCategoryPayloadType = {
  category_name: string;
  onSuccess?: (message?: string) => void;
  onError?: (message?: string) => void;
};

export const deletePartnerProgramBenefitCategorySagaAction: (
  data: DeleteBenefitCategoryPayloadType
) => {
  type: string;
  payload: DeleteBenefitCategoryPayloadType;
} = (data: DeleteBenefitCategoryPayloadType) => {
  return {
    type: partnerProgramBenefitsSagaActionTypes.callDeletePartnerProgramBenefitCategorySaga,
    payload: data,
  };
};

export type DeleteBenefitPayloadType = {
  ID: number;
  onSuccess?: (message?: string) => void;
  onError?: (message?: string) => void;
};

export const deletePartnerProgramBenefitSagaAction: (
  data: DeleteBenefitPayloadType
) => {
  type: string;
  payload: DeleteBenefitPayloadType;
} = (data: DeleteBenefitPayloadType) => {
  return {
    type: partnerProgramBenefitsSagaActionTypes.callDeletePartnerProgramBenefitSaga,
    payload: data,
  };
};
